
import { defineComponent, reactive, toRefs } from "vue";

export default defineComponent({
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["add-submit", "close-modal"],
  setup(props, context) {
    const state = reactive({
      filter: {
        state: "1",
        remark: "",
        timeSlot: '1',
        count: 100
      },
      clickModalClose: false,
    });
    //确认审核
    function addSubmit() {
      context.emit("add-submit", state.filter);
    }
    //取消审核
    function cancel() {
      state.filter.state = "1";
      state.filter.remark = "";
      context.emit("close-modal");
    }
    return {
      ...toRefs(state),
      addSubmit,
      cancel,
    };
  },
});
